<template>
    <starZenAssignmentComponent/>
</template>

<script>
import starZenAssignmentComponent from "@/views/star_assignment/star_assignment_zen/components/list_zen_stars_request_list_component.vue"
export default {
    name: "starAssignment",
    components: {
        starZenAssignmentComponent
    },
}
</script>

<style lang="css" scoped>
</style>